import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';



export interface DetailGroupProps {
    title: string;
}

class DetailGroup extends React.PureComponent<DetailGroupProps & WithStyles<typeof styles>> {

    render() {
        const { title, children, classes } = this.props;
        return <div className={classes.root}>
            <div className={classes.title}>{title}</div>
            <div className={classes.content}>{children}</div>
        </div>
    }
}



export const styles = (theme: Theme) => createStyles({
    root: {
        marginTop: theme.spacing.unit,
        //padding: theme.spacing.unit * 2,
    },
    title: {
        borderBottom: '1px solid silver',
        paddingBottom: theme.spacing.unit,
        paddingTop: theme.spacing.unit,
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        color: 'darkgrey'
    },
    content: {
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
    },
});


export default withStyles(styles)(DetailGroup);